import React from "react";
import {Tooltip, Overlay} from 'react-bootstrap';
import "./style.css";

const InitialValue = [
  {
    id: 1,
    name: "Customer Review",
    key: "Customer Review"
  },
  {
    id: 2,
    name: "Evidence Review",
    key: "Evidence Review"
  },
  {
    id: 3,
    name: "Finding Closed",
    key: "Closed"
  },
];

interface CarStatusProps {
  status: string;
}

const CarStatusTracker: React.FC<CarStatusProps> = ({ status }) => {

  return (
    <div className="flex justify-center">
      <section className="3xl:scale-125">
        <ul className="step-wizard-list">
          {InitialValue.map((item, i) => (
            <li
              key={i}
              className={`step-wizard-item ${
                typeof status === "string" && item.key === status ? "current-item" : ""
               
              } ${item.key.includes(status) ? "current-item" : ""}`}
            >
              <span className="progress-count"></span>
              <span className="progress-label">{item.name}</span>
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
};

export default CarStatusTracker;
